import { createAxiosInstance } from '@/plugins/axios.plugin';
import { validateQueryParameters } from '@/helpers/verifyQueryParameters';

export class CategoriesService {
  static SERVICE_NAME = 'categories';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getAllCategories() {
    return this.client.get('academic/courses/category');
  }

  createCategory(category) {
    return this.client.post('academic/courses/category/new', category);
  }

  getCategoryById(categoryId) {
    return this.client.get(`academic/courses/category/${categoryId}`);
  }

  editCategory(category) {
    return this.client.put(`academic/courses/category/${category.id}`, category);
  }

  deleteCategory(id) {
    return this.client.delete(`academic/courses/category/${id}`);
  }

  getMyCategories({ flat = false, appendDisciplines = false, isVisible, periodIds }) {
    const query = validateQueryParameters({
      flat,
      appendDisciplines,
      isVisible,
      periodIds
    }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`academic/me/category?${query}`);
  }

  getCategoriesFiltered(params) {
    const query = validateQueryParameters(params);
    return this.client.get(`academic/messages/categories?${query}`);
  }
}

export default new CategoriesService();